import { Injectable } from '@angular/core';
import { FormBase } from './form-base';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { DynamicFormArrayBase } from './dynamic-form-base';

@Injectable({ providedIn: 'root' })
export class FormBaseControlService {

	constructor(private formBuilder: FormBuilder) { }

	toFormGroup(elements: DynamicFormArrayBase<any>[], data?: any) {
		const group: any = {};
		elements.forEach(element => {
			if (element.control.field.mapTo) {
				group[element.control.field.mapTo.controlKey] = new FormControl({ value: '', hidden: true });
			}
			switch (element.control.field.controlType) {
				case 'select':
					group[element.key] = element.control.field.required ? new FormControl(
						element.control.field.value || '', Validators.required
					) : new FormControl(element.control.field.value || '');
					break;
				case 'textbox':
					if (element.control.field.required && element.control.field.pattern) {
						group[element.key] = new FormControl(element.control.field.value || '',
							[Validators.required, Validators.pattern(element.control.field.pattern)]);
					} else if (element.control.field.required && !element.control.field.pattern) {
						group[element.key] = new FormControl(element.control.field.value || '',
							Validators.required);
					} else if (!element.control.field.required && element.control.field.pattern) {
						group[element.key] = new FormControl(element.control.field.value || '',
							Validators.pattern(element.control.field.pattern));
					} else {
						group[element.key] = new FormControl(element.control.field.value || '', []);
					}
					break;
				case 'number':
					if (element.control.field.required && element.control.field.pattern) {
						group[element.key] = new FormControl(element.control.field.value || '',
							[Validators.required, Validators.pattern(element.control.field.pattern)]);
					} else if (element.control.field.required && !element.control.field.pattern) {
						group[element.key] = new FormControl(element.control.field.value || '',
							Validators.required);
					} else if (!element.control.field.required && element.control.field.pattern) {
						group[element.key] = new FormControl(element.control.field.value || '',
							Validators.pattern(element.control.field.pattern));
					} else {
						group[element.key] = new FormControl(element.control.field.value || '', []);
					}
					break;
				case 'textarea':
					if (element.control.field.required && element.control.field.pattern) {
						group[element.key] = new FormControl(element.control.field.value || '',
							[Validators.required, Validators.pattern(element.control.field.pattern)]);
					} else if (element.control.field.required && !element.control.field.pattern) {
						group[element.key] = new FormControl(element.control.field.value || '',
							Validators.required);
					} else if (!element.control.field.required && element.control.field.pattern) {
						group[element.key] = new FormControl(element.control.field.value || '',
							Validators.pattern(element.control.field.pattern));
					} else {
						group[element.key] = new FormControl(element.control.field.value || '', []);
					}
					break;
				case 'radio':
					if (element.control.field.required) {
						group[element.key] = new FormControl(element.control.field.value || '',
							[Validators.required]);
					} else {
						group[element.key] = new FormControl(element.control.field.value || '', []);
					}
					break;
				case 'checkbox':
					group[element.key] = new FormGroup({});
					const formData = group[element.key] as FormGroup;
					// if (element.control.field.atleastRequired) {
					// 	for (let index = 0; index < element.control.field.dataOptions.length; index++) {
					// 		formData.addControl(element.control.field.dataOptions[index].key, new FormControl(
					// 			element.control.field.dataOptions[index].value || false, [Validators.required]
					// 		));
					// 	}
					// } else {
					element.control.field.dataOptions.filter(x => {
						formData.addControl(x.key, new FormControl(x.value || false));
					});
					// }
					break;
				case 'file':
					if (element.control.field.file.mapTo.groupName) {
						group[element.control.field.file.mapTo.groupName] = new FormGroup({});
						const fileGroup = group[element.control.field.file.mapTo.groupName] as FormGroup;
						element.control.field.file.mapTo.controls.filter(x => {
							fileGroup.addControl(x.key, new FormControl('', [Validators.required]));
						});
					} else {
						element.control.field.file.mapTo.controls.filter(x => {
							group[x.key] = new FormControl('', element.control.field.required ? [Validators.required] : []);
						});
					}
					break;
				case 'date':
					group[element.key] = new FormControl('', (element.control.field.required ? [Validators.required] : []));
					break;

				default:
					break;
			}
		});
		return new FormGroup(group);
	}

	// toFormGroup(formElements: FormBase<any>[], data: any) {
	// 	console.log('to-form-group', formElements);

	// 	const group: any = {};

	// 	formElements.forEach(element => {
	// 		if (element.controlType === 'checkbox') {
	// 			group[element.key] = this.formBuilder.group({});
	// 			element['options'].filter(x => {
	// 				group[element.key].addControl(x.key, new FormControl(((data && data[element.key] === true)
	// 					? data[element.key] : ''))); // x.value === true ? x.value : ''
	// 			});
	// 		} else if (element.controlType === 'file') {
	// 			group[element.key] = this.formBuilder.group({});
	// 			const controls = Object.keys(element['options']);
	// 			controls.filter(x => {
	// 				group[element.key].addControl(x, new FormControl((element['options'][x] !== '' ? element['options'][x] : '')));
	// 			});
	// 		} else {
	// 			if (element.required && element.pattern !== undefined) {
	// 				group[element.key] = new FormControl(data ? data[element.key] : '', [Validators.required, Validators.pattern(element.pattern)]);
	// 			} else if (!element.required && element.pattern !== undefined) {
	// 				group[element.key] = new FormControl(data ? data[element.key] : '', Validators.pattern(element.pattern));
	// 			} else {
	// 				group[element.key] = new FormControl(data ? data[element.key] : '');
	// 			}
	// 		}
	// 	});
	// 	console.log('formGroup generated', group);
	// 	return new FormGroup(group);
	// }

}
